import { View } from "@react-pdf/renderer";

export const PDFTableBody = ({ children }: { children: React.ReactNode }) => {
  return (
    <View
      style={{
        borderBottomWidth: 1,
        borderColor: "#7C8493",
      }}
    >
      {children}
    </View>
  );
};
